import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/homeContent";

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (!menuOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setMenuOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [menuOpen]);

  const close = () => setMenuOpen(false);

  return (
    <header className="sticky top-0 z-50">
      {/* 更新条 压顶 */}
      <div className="w-full bg-foreground-950 text-background-50">
        <div className="mx-auto flex max-w-[1200px] items-center justify-between gap-3 px-4 py-2 text-xs md:px-6 md:text-sm">
          <div className="flex min-w-0 items-center gap-2">
            <span className="flex h-4 w-4 items-center justify-center text-accent-300">
              <i className="ri-timer-flash-line"></i>
            </span>
            <span className="truncate">
              内容持续整理中 · 最近更新 2026-10-06
            </span>
          </div>
          <a
            href="#watch"
            className="hidden shrink-0 items-center gap-1 whitespace-nowrap text-background-200 transition-colors hover:text-background-50 sm:inline-flex"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-circle-line"></i>
            </span>
            查看观看方式
          </a>
        </div>
      </div>

      {/* 导航 */}
      <div className="border-b border-background-200 bg-background-50/95 backdrop-blur">
        <div className="mx-auto flex max-w-[1200px] items-center justify-between gap-4 px-4 py-3 md:px-6">
          <a href="#home" className="flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-lg text-background-50">
              <i className="ri-book-read-line"></i>
            </span>
            <span className="font-heading text-base font-bold tracking-tight text-foreground-950 md:text-lg">
              善良的女秘书
            </span>
          </a>

          <nav className="hidden items-center gap-1 lg:flex">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                className="rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-800"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#watch"
              className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex md:items-center md:gap-1"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-play-fill"></i>
              </span>
              立即观看
            </a>
            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              aria-expanded={menuOpen}
              aria-label="打开导航菜单"
              className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-lg text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
            >
              <i className={menuOpen ? "ri-close-line" : "ri-menu-line"}></i>
            </button>
          </div>
        </div>

        {menuOpen && (
          <nav className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
            <div className="flex flex-col">
              {navLinks.map((link) => (
                <a
                  key={link.id}
                  href={`#${link.id}`}
                  onClick={close}
                  className="rounded-md px-3 py-2.5 text-sm text-foreground-800 transition-colors hover:bg-primary-100 hover:text-primary-800"
                >
                  {link.label}
                </a>
              ))}
              <a
                href="#watch"
                onClick={close}
                className="mt-2 inline-flex items-center justify-center gap-1 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-play-fill"></i>
                </span>
                立即观看
              </a>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}